import React from "react";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ControlledInputProps } from "./ControlledInput";

const ControlledPhoneInput: React.FC<ControlledInputProps> = ({
  control,
  name,
  label,
  defaultValue = "",
  rules = {},
}) => (
  <Controller
    control={control}
    name={name}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
        <PhoneInput
          country={"ca"}
          value={value}
          onChange={(phone) => onChange(phone)}
          inputStyle={{
            height: "40px",
            borderRadius: "8px",
            border: "1px solid #C8D2DE",
            padding: "10px 12px 10px 45px",
            fontSize: "14px",
            fontWeight: "500",
            color: "#1D2C3B",
            outline: "none",
            transition: "all 0.3s",
          }}
          containerStyle={{
            marginBottom: error ? "0.5rem" : "0",
            borderRadius: "8px",
          }}
          inputProps={{
            placeholder: "Phone Number...",
            onFocus: (e: React.FocusEvent<HTMLInputElement>) => {
              e.target.style.border = "1px solid #6938EF";
              e.target.style.boxShadow = "0 0 0 4px rgba(105, 56, 239, 0.2)";
            },
            onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
              e.target.style.border = "1px solid #C8D2DE";
              e.target.style.boxShadow = "none";
            },
          }}
        />
        {error && <span className="text-red-500 text-sm">{error.message}</span>}
      </div>
    )}
  />
);

export default ControlledPhoneInput;
